export const arrayToDictionary = (items, key = 'id') =>
  items.reduce(
    (dictionary, item) => ({
      ...dictionary,
      [item[key]]: item,
    }),
    {}
  );
